import { Box } from "@mui/material";

import { setupManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { TitlesColumns } from "../../../../data/Columns/SystemSetupColumns";
import {
  PayBillsColumns,
  TitleFSColumns,
} from "../../../../data/Columns/FSColumns";
import {
  allFSTitles,
  allPayBills,
  newAllInsightKeyWords,
  newAllPaybills,
} from "../../../../data/Queries/SetupManagement/FinSightsQueries";
import PayBillsForm from "./form";

const base_url = setupManagementUrl.uri;
const actions = {
  entity: "Paybills",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  showStatus: true,
};
function PayBillsTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="All Paybils"
          subtitle="View, create or edit Paybils "
          columns={PayBillsColumns}
          FormComponent={PayBillsForm}
          query={newAllPaybills}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default PayBillsTable;
